import { useHistory } from "react-router-dom";
import { useEffect } from 'react';
// import { useSelector, useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';

// import { fetchNotifications } from 'reducers/notificationsReducer';
// import { usePageTitle } from 'utils/pageTitle';
import AdminNav from 'pages/_rd_dashboard/AdminNav';
import { isAdminUser } from 'utils/userUtils';
// import Portfolio from 'pages/_rd_dashboard/_rd_Portfolio';
 
import './DashboardLayout.css';

const AdminLayout = ({ children }) => {
	const history = useHistory();
	// const dispatch = useDispatch();
	let {
		isLoggedIn,
		isAdmin,
		isLoading,
		isUpdating,
	} = useSelector(state => ({
		isLoggedIn: !!state.user.userData?.id,
		isAdmin: isAdminUser(state.user.userData),
		isLoading: state.user.isLoading,
		isUpdating: state.user.isUpdating,
	}));

	useEffect(() => {
		if (isLoading || isUpdating) {
			return;
		}
		if (!isLoggedIn) {
			history.replace('/sign-in');
			return;
		}
		if (!isAdmin) {
			history.replace('/dashboard/overview');
		}
	}, [isLoggedIn, isAdmin, isLoading, isUpdating, history]);

	if (!isAdmin) {
		return null;
	}

	return (
		<div className="rd-dashboard">
			<AdminNav />
			<div className="rd-dashboard-content">
				{children}
			</div>
		</div>
	);
}

export default AdminLayout;
